
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import { Cropper } from "vue-advanced-cropper";
  import { resizeCanvas } from "@/utils/resizeCanvas";
  import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
  import UiButton from "@/components/button/ui-button.vue";

  @Component({
    components: {
      Cropper,
      ModalFullScreen,
      UiButton,
    },
  })
  export default class ImageCropper extends Vue {
    @Prop({ type: String, required: false }) image!: string;
    @Prop({ type: Boolean, default: false }) readonly dialog!: boolean;

    loading: boolean = true;

    @Watch('image', { immediate: true })
    onImageChange() {
      this.loading = true;
    }

    onImageLoaded() {
      this.loading = false;
    }

    async uploadImage(): Promise<void> {
      const { canvas } = (this.$refs.cropper as any).getResult();
      
      if (canvas) {
        const blob = await resizeCanvas(canvas, 500, 500, "image/jpeg");
        this.$emit("imageCropped", blob);
      }
      (this.$refs.cropper as any).reset();
      this.$emit("closeModal");
    }

    handleClose(): void {
      (this.$refs.cropper as any).reset();
      this.$emit("closeModal");
    }
  }
